import { createEndpoint, createEndpointWithNumberedPagination } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import { CitySchema, CityWithCountrySchema } from "../schemas/cities";

export interface CountryCitiesQueryParams extends QueryParams {
    /** Prefix match on the name or any word in it. Max 100 chars. */
    q?: string;
    /** 1-200, default 50. Results are ordered by population, then name, then id. */
    per_page?: number;
}

export interface CitiesByIdsQueryParams extends QueryParams {
    /** Comma-separated GeoNames ids, at most 200. Unknown ids are omitted. */
    ids: string;
}

export function createCitiesApi(http: HttpClient, baseUrl: string) {
    return {
        /** GET /countries/:country/cities?q=&page=&per_page= — `country` is an ISO 3166-1 alpha-2 code. */
        getCountryCities: createEndpointWithNumberedPagination<
            typeof CitySchema._output,
            unknown,
            unknown,
            CountryCitiesQueryParams,
            { country: string }
        >(http, "GET", "/countries/:country/cities", {
            base: baseUrl,
            itemSchema: CitySchema,
        }),

        /** GET /cities?ids=1,2,3 — resolves ids to `{ id, name, region, country }` regardless of country. */
        getCitiesByIds: createEndpoint<
            typeof CityWithCountrySchema._output[],
            unknown,
            CitiesByIdsQueryParams
        >(http, "GET", "/cities", {
            base: baseUrl,
            responseSchema: CityWithCountrySchema.array(),
        }),
    };
}
